module.exports = __webpack_public_path__ + "static/img/zip-icon.4c6f9710.svg";